export const INVERSION = 1;
export const SAAS = 2;
export const CUOTA_SIMPLE = 3;

export const nombres = Object.freeze({
  [INVERSION]: "Inversión",
  [SAAS]: "SaaS",
  [CUOTA_SIMPLE]: "Cuota",
});

export const combo = Object.keys(nombres).map((k) => {
  return { value: k, text: nombres[k] };
});

export function nombreTipoProyecto(tipo) {
  return nombres[tipo];
}

export default { INVERSION, SAAS, CUOTA_SIMPLE, nombres, combo };
